/**
 * Vista: Detalle/Nuevo Certificado de Venta
 * Formato: AMX-VTA-FR-09
 */

import ventasService from '../services/ventas.service.js';
import tractorService from '../services/tractor.service.js';
import personaService from '../services/persona.service.js';
import recepcionService from '../services/recepcion.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';

import { hoyLocal } from '../utils/fechas.js';
// Constantes
const ITEMS_PROTOCOLO = [
  'Recibí tractor/cosechadora nueva, juego de llaves de encendido y accesorios de regalo.',
  'Recibí Manual de operación, Póliza de garantía y Carnet de garantía.',
  'Recibí instrucciones sobre las normas de seguridad, procedimientos operativos básicos, inspección diaria, mantenimientos obligatorios y las condiciones que regulan la cobertura de garantía del equipo.',
  'Se me instruyó sobre las especificaciones técnicas establecidas para aceites, lubricantes y refrigerantes; y cómo mantener los niveles correctos.',
  'Se verificó el buen estado del tractor/cosechadora, junto con los neumáticos, niveles de aceite y refrigerante.',
  'Se me instruyó y verificó el funcionamiento del tablero de instrumentos, aplicación de indicadores y alertas.',
  'Se verificó el funcionamiento general del motor, sistema de dirección, hidráulico, transmisión y frenos.',
  'Se verificó el correcto funcionamiento del sistema eléctrico.',
  'Conozco el periodo de aplicación de los servicios de mantenimiento preventivo de tractor y cosechadora (50 hr, 350 hr, 650 hr, 950 hr, 1250 hr, 1550 hr y 1850 hr).'
];

export default {
  data: {
    certificado: null,
    tractor: null,
    isNew: false,
    isEdit: false,
    clienteSeleccionado: null
  },

  async render(params) {
    this.data.isNew = !params.id || params.id === 'nuevo';

    return `
      <div class="card">
        <div id="certificadoHeader" class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">${this.data.isNew ? 'Nuevo Certificado de Venta' : 'Certificado de Venta'}</h2>
          <button class="btn btn-secondary" onclick="router.navigate('/ventas/certificados')">
            Volver a Lista
          </button>
        </div>

        <div id="certificadoContent">
          <div style="text-align: center; padding: 2rem;">
            Cargando...
          </div>
        </div>
      </div>
    `;
  },

  async afterRender(params) {
    window.certificadoDetalleView = this;

    if (this.data.isNew) {
      await this.cargarClientes();
      this.renderFormularioNuevo();
    } else {
      await this.cargarCertificado(params.id);
    }
  },

  async cargarClientes() {
    try {
      const response = await personaService.list({ rol: 'cliente', limit: 500 });
      const list = response.data?.personas || response.personas || response.data || response || [];
      this.data.clientes = Array.isArray(list) ? list : [];
    } catch (error) {
      console.error('Error al cargar clientes:', error);
      this.data.clientes = [];
    }
  },

  async cargarCertificado(id) {
    try {
      const response = await ventasService.obtenerCertificado(id);
      this.data.certificado = response.data || response;
      this.data.isEdit = true;

      // Resetear signaturePads previos para evitar re-subir firmas ya persistidas
      this.signaturePad_empresa = null;
      this.signaturePad_cliente = null;

      this.renderCertificadoExistente();
    } catch (error) {
      toast.error('Error al cargar certificado');
      console.error(error);
      router.navigate('/ventas/certificados');
    }
  },

  renderFormularioNuevo() {
    const container = document.getElementById('certificadoContent');

    container.innerHTML = `
      <form id="formCertificado">
        <!-- Buscar Tractor -->
        <div style="background: white; border: 1px solid var(--gray-200); padding: 1.25rem 1.5rem; border-radius: 8px; margin-bottom: 1rem;">
          <h4 style="margin: 0 0 0.25rem; font-size: 1rem; font-weight: 600;">Buscar por número de serie</h4>
          <p style="margin: 0 0 1rem; color: var(--text-muted); font-size: 0.85rem;">Ingrese el número de serie del tractor para cargar sus datos automáticamente</p>
          <div style="display: flex; gap: 0.75rem; align-items: center;">
            <input
              type="text"
              id="numSerieBuscar"
              class="form-input"
              style="flex: 1;"
              placeholder="Ej: TE354-2026-0127"
            />
            <button type="button" class="btn btn-primary" onclick="window.certificadoDetalleView.buscarTractor()">
              Buscar
            </button>
          </div>
          <div id="tractorResult" style="margin-top: 1rem;"></div>
        </div>

        <!-- Formulario principal -->
        <div id="formularioPrincipal" style="display: none;">
          <input type="hidden" name="num_serie" id="numSerie" />

          <!-- Datos del Equipo -->
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
            <h3 style="margin-bottom: 1rem;">Datos del Equipo</h3>
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
              <div class="form-group">
                <label class="form-label">Marca</label>
                <input
                  type="text"
                  id="marca"
                  class="form-input"
                  readonly
                  style="background: var(--bg-secondary);"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Modelo</label>
                <input
                  type="text"
                  name="modelo"
                  id="modelo"
                  class="form-input"
                  readonly
                  style="background: var(--bg-secondary);"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Serie del Motor</label>
                <input
                  type="text"
                  name="serie_motor"
                  id="serieMotor"
                  class="form-input"
                  readonly
                  style="background: var(--bg-secondary);"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Fecha *</label>
                <input
                  type="date"
                  name="fecha"
                  class="form-input"
                  value="${hoyLocal()}"
                  required
                />
              </div>
            </div>
          </div>

          <!-- Datos del Propietario -->
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
            <h3 style="margin-bottom: 1rem;">Datos del Propietario</h3>

            <!-- Select de Cliente -->
            <div class="form-group" style="margin-bottom: 1rem;">
              <label class="form-label">Cliente *</label>
              <input type="hidden" name="cliente_id" id="clienteId" />
              <select id="clienteSelect" class="form-select" onchange="window.certificadoDetalleView._onClienteSelectChange(this)">
                <option value="">Seleccione un cliente...</option>
                ${(this.data.clientes || []).map(c => `
                  <option value="${c.id}" data-nombre="${c.nombre_completo}" data-rfc="${c.rfc || ''}" data-direccion="${c.direccion || ''}" data-telefono="${c.telefono || ''}" data-email="${c.email || ''}">${c.nombre_completo}${c.rfc ? ` - ${c.rfc}` : ''}</option>
                `).join('')}
              </select>
            </div>

            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
              <div class="form-group">
                <label class="form-label">Nombre del Propietario</label>
                <input
                  type="text"
                  name="propietario"
                  id="inputPropietario"
                  class="form-input"
                  placeholder="Nombre completo"
                  required
                />
              </div>
              <div class="form-group">
                <label class="form-label">RFC</label>
                <input
                  type="text"
                  name="rfc"
                  id="inputRfc"
                  class="form-input"
                  placeholder="Ej: XAXX010101000"
                  maxlength="13"
                  required
                />
              </div>
              <div class="form-group">
                <label class="form-label">Teléfono</label>
                <input
                  type="tel"
                  name="telefono"
                  id="inputTelefono"
                  class="form-input"
                  placeholder="Ej: 555-123-4567"
                  required
                />
              </div>
              <div class="form-group">
                <label class="form-label">Correo Electrónico</label>
                <input
                  type="email"
                  name="correo"
                  id="inputCorreo"
                  class="form-input"
                  placeholder="correo@ejemplo.com"
                />
              </div>
              <div class="form-group">
                <label class="form-label">Dirección</label>
                <input
                  type="text"
                  name="direccion"
                  id="inputDireccion"
                  class="form-input"
                  placeholder="Dirección completa"
                  required
                />
              </div>
              <div class="form-group">
                <label class="form-label">Lugar</label>
                <input
                  type="text"
                  name="lugar"
                  id="inputLugar"
                  class="form-input"
                  placeholder="Ciudad, Estado"
                  required
                />
              </div>
            </div>
          </div>

          <!-- Protocolo de Entrega -->
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
            <h3 style="margin-bottom: 1rem;">Protocolo de Entrega (9 items)</h3>
            <div style="display: grid; grid-template-columns: 1fr; gap: 0.5rem;">
              ${ITEMS_PROTOCOLO.map((item, i) => `
                <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer; padding: 0.5rem; border-bottom: 1px solid var(--border-color);">
                  <input type="checkbox" name="protocolo_${i}" value="${i + 1}" />
                  <span><strong>${i + 1}.</strong> ${item}</span>
                </label>
              `).join('')}
            </div>
          </div>

          <!-- Botones -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button type="button" class="btn btn-secondary" onclick="router.navigate('/ventas/certificados')">
              Cancelar
            </button>
            <button type="submit" class="btn btn-success">
              Crear Certificado
            </button>
          </div>
        </div>
      </form>
    `;

    document.getElementById('formCertificado').addEventListener('submit', (e) => this.guardarNuevo(e));

    // Buscar al presionar Enter; ocultar formulario si modifican el NS después de buscar
    const nsBuscar = document.getElementById('numSerieBuscar');
    if (nsBuscar) {
      nsBuscar.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.buscarTractor();
        }
      });
      nsBuscar.addEventListener('input', () => {
        if (this.data.tractor) {
          this.data.tractor = null;
          const fp = document.getElementById('formularioPrincipal');
          if (fp) fp.style.display = 'none';
          const result = document.getElementById('tractorResult');
          if (result) result.innerHTML = '';
        }
      });
    }
  },

  _onClienteSelectChange(select) {
    if (!select.value) {
      this.limpiarCliente();
      return;
    }
    this.seleccionarCliente(parseInt(select.value, 10));
  },

  async seleccionarCliente(clienteId) {
    try {
      // Obtener datos completos del cliente
      const response = await personaService.getById(clienteId);
      const cliente = response.persona || response;
      this.data.clienteSeleccionado = cliente;

      // Guardar ID
      const idEl = document.getElementById('clienteId');
      if (idEl) idEl.value = clienteId;

      // Sincronizar select
      const selectEl = document.getElementById('clienteSelect');
      if (selectEl) selectEl.value = String(clienteId);

      // Auto-rellenar campos del formulario (inputs de propietario)
      const set = (id, val) => { const el = document.getElementById(id); if (el) el.value = val || ''; };
      set('inputPropietario', cliente.nombre_completo);
      set('inputRfc', cliente.rfc);
      set('inputTelefono', cliente.telefono || cliente.celular);
      set('inputCorreo', cliente.email);
      set('inputDireccion', cliente.direccion);
      set('inputLugar', [cliente.ciudad, cliente.estado].filter(Boolean).join(', '));

      // Bloquear nombre y RFC
      ['inputPropietario', 'inputRfc'].forEach(id => {
        const el = document.getElementById(id);
        if (el) { el.readOnly = true; el.style.background = 'var(--bg-secondary)'; }
      });
    } catch (error) {
      console.error('Error obteniendo datos del cliente:', error);
      toast.error('Error al obtener datos del cliente');
    }
  },

  limpiarCliente() {
    this.data.clienteSeleccionado = null;
    const idEl = document.getElementById('clienteId');
    if (idEl) idEl.value = '';
    const selectEl = document.getElementById('clienteSelect');
    if (selectEl) selectEl.value = '';

    // Limpiar inputs
    ['inputPropietario', 'inputRfc', 'inputTelefono', 'inputCorreo', 'inputDireccion', 'inputLugar'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });

    // Desbloquear nombre y RFC
    ['inputPropietario', 'inputRfc'].forEach(id => {
      const el = document.getElementById(id);
      if (el) { el.readOnly = false; el.style.background = ''; }
    });
  },

  async buscarTractor() {
    const numSerie = document.getElementById('numSerieBuscar').value;
    if (!numSerie) {
      toast.error('Ingrese el número de serie');
      return;
    }

    const resultDiv = document.getElementById('tractorResult');
    resultDiv.innerHTML = '<p>Buscando...</p>';

    try {
      const response = await tractorService.getByNumSerie(numSerie);
      const tractor = response.data || response;
      this.data.tractor = tractor;

      // Verificar si el tractor tiene cliente asignado
      const tieneCliente = tractor.cliente && tractor.cliente.id;

      resultDiv.innerHTML = '';

      // Mostrar formulario y prellenar datos
      document.getElementById('formularioPrincipal').style.display = 'block';
      document.getElementById('numSerie').value = numSerie;
      document.getElementById('marca').value = tractor.marca || '';
      document.getElementById('modelo').value = tractor.modelo || '';
      document.getElementById('serieMotor').value = tractor.serie_motor || '';

      // Auto-rellenar cliente desde el tractor si existe
      if (tieneCliente) {
        await this.seleccionarCliente(tractor.cliente.id);
      }

    } catch (error) {
      this.data.tractor = null;
      resultDiv.innerHTML = `
        <div style="padding: 1rem; background: var(--danger); color: white; border-radius: 8px;">
          ${error.message || 'Tractor no encontrado'}
        </div>
      `;
      document.getElementById('formularioPrincipal').style.display = 'none';
      console.error(error);
    }
  },

  renderCertificadoExistente() {
    const container = document.getElementById('certificadoContent');
    const c = this.data.certificado;
    const completada = c.completada;

    container.innerHTML = `
      <form id="formEditCertificado">
        <!-- Datos del Equipo (siempre visibles) -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Datos del Equipo</h3>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
            <div><strong>Num. Serie:</strong><br>${c.num_serie}</div>
            <div><strong>Marca:</strong><br>${c.marca || '-'}</div>
            <div><strong>Modelo:</strong><br>${c.modelo}</div>
            <div><strong>Serie Motor:</strong><br>${c.serie_motor}</div>
            <div><strong>Fecha:</strong><br>${new Date(c.fecha).toLocaleDateString('es-MX')}</div>
          </div>
        </div>

        <!-- Datos del Propietario (siempre visibles) -->
        <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; margin-bottom: 1.5rem;">
          <h3 style="margin-bottom: 1rem;">Datos del Propietario</h3>
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
            <div><strong>Nombre:</strong><br>${c.propietario}</div>
            <div><strong>RFC:</strong><br>${c.rfc}</div>
            <div><strong>Teléfono:</strong><br>${c.telefono || '-'}</div>
            <div><strong>Correo:</strong><br>${c.correo || '-'}</div>
            <div><strong>Dirección:</strong><br>${c.direccion || '-'}</div>
            <div><strong>Lugar:</strong><br>${c.lugar || '-'}</div>
          </div>
        </div>

        <!-- Tabs: Protocolo y Firmas -->
        <div class="cert-tabs-bar">
          <button type="button" class="cert-tab active" onclick="window.certificadoDetalleView.showTab('protocolo')">Protocolo</button>
          <button type="button" class="cert-tab" onclick="window.certificadoDetalleView.showTab('firmas')">Firmas</button>
        </div>

        <!-- Panel: Protocolo -->
        <div id="panel-protocolo" class="cert-panel">
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
            <h3 style="margin-bottom: 1rem;">Protocolo de Entrega</h3>
            <div style="display: grid; grid-template-columns: 1fr; gap: 0.5rem;">
              ${ITEMS_PROTOCOLO.map((item, i) => {
                const protocoloItem = c.protocolo_items?.find(p => p.item_numero === (i + 1));
                const verificado = protocoloItem?.verificado || false;
                if (completada) {
                  return `
                    <div style="display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem; border-bottom: 1px solid var(--border-color);">
                      <span style="color: ${verificado ? 'var(--success)' : 'var(--text-muted)'}; font-size: 1.2rem;">
                        ${verificado ? '✓' : '○'}
                      </span>
                      <span><strong>${i + 1}.</strong> ${item}</span>
                    </div>
                  `;
                }
                return `
                  <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer; padding: 0.5rem; border-bottom: 1px solid var(--border-color);">
                    <input type="checkbox" name="protocolo_${i}" value="${i + 1}" ${verificado ? 'checked' : ''} />
                    <span><strong>${i + 1}.</strong> ${item}</span>
                  </label>
                `;
              }).join('')}
            </div>
          </div>
        </div>

        <!-- Panel: Firmas -->
        <div id="panel-firmas" class="cert-panel" style="display: none;">
          <div style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px;">
            <h3 style="margin-bottom: 1rem;">Firmas</h3>
            <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
              ${completada ? `
                <div style="text-align: center;">
                  ${c.firma_empresa_url ? `<img src="${c.firma_empresa_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />` : ''}
                  <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
                    <strong>AGROMX</strong><br>
                    <small style="color: var(--text-muted);">Empresa</small>
                  </div>
                </div>
                <div style="text-align: center;">
                  ${c.firma_cliente_url ? `<img src="${c.firma_cliente_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />` : ''}
                  <div style="border-top: 1px solid var(--gray-400); padding-top: 0.5rem; text-align: center;">
                    <strong>${c.propietario || '-'}</strong><br>
                    <small style="color: var(--text-muted);">Cliente</small>
                  </div>
                </div>
              ` : `
                <div class="firma-container-new" style="text-align: center;">
                  <label class="form-label firma-label">Firma AGROMX</label>
                  ${c.firma_empresa_url ? `
                    <img src="${c.firma_empresa_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                    <a href="javascript:void(0)" class="firma-limpiar" onclick="window.certificadoDetalleView.limpiarFirmaExistente('empresa')">Cambiar firma</a>
                  ` : `
                    <div class="firma-box">
                      <canvas id="firma-empresa" class="firma-canvas-new"></canvas>
                      <span class="firma-placeholder">Toque para firmar</span>
                    </div>
                    <a href="javascript:void(0)" class="firma-limpiar" onclick="window.certificadoDetalleView.limpiarFirma('empresa')">Limpiar</a>
                  `}
                </div>
                <div class="firma-container-new" style="text-align: center;">
                  <label class="form-label firma-label">Firma Cliente</label>
                  ${c.firma_cliente_url ? `
                    <img src="${c.firma_cliente_url}" style="width: 100%; max-height: 80px; object-fit: contain; margin-bottom: 0.5rem;" onerror="this.style.display='none'" />
                    <a href="javascript:void(0)" class="firma-limpiar" onclick="window.certificadoDetalleView.limpiarFirmaExistente('cliente')">Cambiar firma</a>
                  ` : `
                    <div class="firma-box">
                      <canvas id="firma-cliente" class="firma-canvas-new"></canvas>
                      <span class="firma-placeholder">Toque para firmar</span>
                    </div>
                    <a href="javascript:void(0)" class="firma-limpiar" onclick="window.certificadoDetalleView.limpiarFirma('cliente')">Limpiar</a>
                  `}
                </div>
              `}
            </div>
          </div>
        </div>

        ${!completada ? `
          <div id="unsavedIndicator" style="display: none; background: var(--warning); color: white; padding: 0.5rem 1rem; border-radius: 8px; margin-bottom: 1rem; text-align: center;">
            Hay cambios sin guardar
          </div>
        ` : ''}

        ${!completada ? `
          <!-- Botones -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-top: 1.5rem;">
            <button type="button" class="btn btn-secondary" onclick="window.certificadoDetalleView.volverALista()">
              Volver
            </button>
            <button type="submit" class="btn btn-success">
              Guardar Cambios
            </button>
            ${permisos.can('certificados_venta', 'cerrar') ? `
              <button type="button" class="btn btn-primary" onclick="window.certificadoDetalleView.completarCertificado()">
                Completar
              </button>
            ` : ''}
          </div>
        ` : ''}
      </form>
    `;

    if (!completada) {
      document.getElementById('formEditCertificado').addEventListener('submit', (e) => this.guardarEdicion(e));

      // Detectar cambios sin guardar
      const form = document.getElementById('formEditCertificado');
      form.addEventListener('change', () => this._showUnsaved());
      form.addEventListener('input', () => this._showUnsaved());

      // Prevenir salida accidental
      this._beforeUnloadHandler = (e) => {
        if (this._hasUnsaved) {
          e.preventDefault();
          e.returnValue = '';
        }
      };
      window.addEventListener('beforeunload', this._beforeUnloadHandler);
    }

    // Inyectar estilos de tabs
    if (!document.querySelector('style[data-cert-tabs]')) {
      const style = document.createElement('style');
      style.setAttribute('data-cert-tabs', '');
      style.textContent = `
        .cert-tabs-bar {
          display: flex;
          padding: 0;
          background: transparent;
          border-bottom: 2px solid #e5e7eb;
          margin-bottom: 1rem;
        }
        .cert-tab {
          flex: 1;
          padding: 0.6rem 1rem;
          border: none;
          border-bottom: 3px solid transparent;
          margin-bottom: -2px;
          background: transparent;
          color: #6b7280;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          text-align: center;
        }
        .cert-tab:hover:not(.active) {
          color: #374151;
          border-bottom-color: #d1d5db;
        }
        .cert-tab.active {
          color: var(--primary);
          font-weight: 600;
          border-bottom-color: var(--primary);
        }
        @media (max-width: 640px) {
          .cert-tabs-bar {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 0.3rem;
            padding: 0.3rem;
          }
          .cert-tab {
            padding: 0.4rem 0.5rem;
            font-size: 0.75rem;
          }
        }
      `;
      document.head.appendChild(style);
    }

    // Actualizar header con estado
    const header = document.getElementById('certificadoHeader');
    if (header) {
      header.innerHTML = `
        <div>
          <h2 class="card-title" style="margin: 0;">Certificado de Venta</h2>
          <small style="color: var(--text-muted);">Formato AMX-VTA-FR-09 | ${completada
            ? '<span style="color: var(--success);">Completada</span>'
            : '<span style="color: var(--warning);">Pendiente</span>'
          }</small>
        </div>
        <div style="display: flex; gap: 0.5rem;">
          <button class="btn btn-secondary" onclick="window.certificadoDetalleView.volverALista()">
            &larr; Volver
          </button>
          ${completada && permisos.canPrint('certificados_venta') ? `
            <button class="btn btn-primary" onclick="router.navigate('/ventas/certificados/${c.id}/print')">
              🖨️ Imprimir
            </button>
            <button class="btn btn-success" onclick="window.certificadoDetalleView.descargarPDF()">
              📄 Descargar PDF
            </button>
          ` : ''}
        </div>
      `;
    }
  },

  showTab(tab) {
    // Actualizar botones activos
    document.querySelectorAll('.cert-tab').forEach(btn => btn.classList.remove('active'));
    const tabButton = document.querySelector(`.cert-tab[onclick*="'${tab}'"]`);
    if (tabButton) tabButton.classList.add('active');

    // Mostrar/ocultar paneles
    document.querySelectorAll('.cert-panel').forEach(p => p.style.display = 'none');
    const panel = document.getElementById(`panel-${tab}`);
    if (panel) panel.style.display = 'block';

    // Inicializar firmas cuando se muestra el tab de firmas
    if (tab === 'firmas' && !this.data.certificado.completada && !this.signaturePad_empresa) {
      this.initFirmas();
    }
  },

  async initFirmas() {
    if (!window.SignaturePad) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/signature_pad/4.1.7/signature_pad.umd.min.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }

    setTimeout(() => {
      ['empresa', 'cliente'].forEach(tipo => {
        const canvas = document.getElementById(`firma-${tipo}`);
        if (!canvas) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);

        const pad = new SignaturePad(canvas, {
          backgroundColor: 'rgb(255, 255, 255)',
          penColor: 'rgb(0, 0, 0)'
        });

        this[`signaturePad_${tipo}`] = pad;

        const placeholder = canvas.parentElement.querySelector('.firma-placeholder');
        const hideOnDraw = () => { if (placeholder) placeholder.style.display = 'none'; };
        canvas.addEventListener('pointerdown', hideOnDraw);
        canvas.addEventListener('touchstart', hideOnDraw);

        // Activar "Hay cambios sin guardar" al terminar un trazo
        if (this._showUnsaved) pad.addEventListener('endStroke', () => this._showUnsaved());
      });
    }, 100);
  },

  _showProgress(message) {
    let overlay = document.getElementById('progressOverlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'progressOverlay';
      overlay.style.cssText = 'position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.9); display: flex; flex-direction: column; align-items: center; justify-content: center; z-index: 9999;';
      overlay.innerHTML = `
        <div class="spinner" style="margin-bottom: 1rem;"></div>
        <p id="progressMessage" style="font-size: 1rem; font-weight: 600; color: var(--gray-700);"></p>
      `;
      document.body.appendChild(overlay);
    }
    document.getElementById('progressMessage').textContent = message;
  },

  _hideProgress() {
    const overlay = document.getElementById('progressOverlay');
    if (overlay) overlay.remove();
  },

  limpiarFirma(tipo) {
    const pad = this[`signaturePad_${tipo}`];
    if (pad) {
      pad.clear();
      const canvas = document.getElementById(`firma-${tipo}`);
      const placeholder = canvas?.parentElement.querySelector('.firma-placeholder');
      if (placeholder) placeholder.style.display = 'block';
    }
  },

  limpiarFirmaExistente(tipo) {
    const c = this.data.certificado;
    if (tipo === 'empresa') c.firma_empresa_url = null;
    if (tipo === 'cliente') c.firma_cliente_url = null;
    this.renderCertificadoExistente();
  },

  async toBlob(signaturePad) {
    const dataURL = signaturePad.toDataURL('image/png');
    const response = await fetch(dataURL);
    return response.blob();
  },

  async subirFirmas() {
    const urls = { firma_empresa_url: null, firma_cliente_url: null };
    const uploads = [];

    const padEmpresa = this.signaturePad_empresa;
    const padCliente = this.signaturePad_cliente;

    const numSerie = this.data.certificado?.num_serie;

    if (padEmpresa && !padEmpresa.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(padEmpresa), `firma-empresa-cert-${Date.now()}.png`, numSerie, 'certificado')
          .then(url => { urls.firma_empresa_url = url; })
      );
    }

    if (padCliente && !padCliente.isEmpty()) {
      uploads.push(
        recepcionService.subirFirma(await this.toBlob(padCliente), `firma-cliente-cert-${Date.now()}.png`, numSerie, 'certificado')
          .then(url => { urls.firma_cliente_url = url; })
      );
    }

    await Promise.all(uploads);
    return urls;
  },

  async guardarNuevo(e) {
    e.preventDefault();

    if (!this.data.tractor) {
      toast.error('Debe buscar y seleccionar un tractor válido primero');
      return;
    }

    const form = e.target;
    const formData = new FormData(form);

    // Construir array de protocolo
    const protocolo_items = [];
    ITEMS_PROTOCOLO.forEach((item, i) => {
      if (formData.get(`protocolo_${i}`)) {
        protocolo_items.push({
          item_numero: i + 1,
          verificado: true
        });
      }
    });

    const clienteId = formData.get('cliente_id');
    const data = {
      num_serie: formData.get('num_serie'),
      fecha: formData.get('fecha'),
      propietario: formData.get('propietario'),
      cliente_id: clienteId ? parseInt(clienteId) : null,
      direccion: formData.get('direccion'),
      lugar: formData.get('lugar'),
      telefono: formData.get('telefono'),
      correo: formData.get('correo') || null,
      rfc: (formData.get('rfc') || '').trim().toUpperCase() || 'XAXX010101000',
      modelo: formData.get('modelo'),
      serie_motor: formData.get('serie_motor'),
      protocolo_items
    };

    try {
      this._showProgress('Creando certificado...');
      const response = await ventasService.crearCertificado(data);
      this._hideProgress();
      toast.success('Certificado creado exitosamente');
      const certificado = response.data || response;
      router.navigate(`/ventas/certificados/${certificado.id}`);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al crear certificado');
      console.error(error);
    }
  },

  activarEdicion() {
    this.data.isEdit = true;
    this.renderCertificadoExistente();
  },

  cancelarEdicion() {
    this.data.isEdit = false;
    this.renderCertificadoExistente();
  },

  async guardarEdicion(e) {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const c = this.data.certificado;

    // Construir protocolo_items
    const protocolo_items = ITEMS_PROTOCOLO.map((item, i) => ({
      item_numero: i + 1,
      verificado: !!formData.get(`protocolo_${i}`)
    }));

    const data = {
      protocolo_items
    };

    try {
      this._showProgress('Subiendo firmas...');
      // Subir firmas si se dibujaron
      const firmaUrls = await this.subirFirmas();
      if (firmaUrls.firma_empresa_url) data.firma_empresa_url = firmaUrls.firma_empresa_url;
      if (firmaUrls.firma_cliente_url) data.firma_cliente_url = firmaUrls.firma_cliente_url;

      this._showProgress('Guardando certificado...');
      await ventasService.actualizarCertificado(c.id, data);
      this._hideProgress();
      this._clearUnsaved();
      toast.success('Certificado actualizado exitosamente');

      // Recargar para reset de pads + re-render con URLs actualizadas (patrón OT/Liberación)
      await this.cargarCertificado(c.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al actualizar certificado');
      console.error(error);
    }
  },

  _showUnsaved() {
    this._hasUnsaved = true;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'block';
  },

  _clearUnsaved() {
    this._hasUnsaved = false;
    const indicator = document.getElementById('unsavedIndicator');
    if (indicator) indicator.style.display = 'none';
    if (this._beforeUnloadHandler) window.removeEventListener('beforeunload', this._beforeUnloadHandler);
  },

  volverALista() {
    if (this._hasUnsaved) {
      if (!confirm('Hay cambios sin guardar. ¿Está seguro de salir?')) return;
    }
    this._clearUnsaved();
    router.navigate('/ventas/certificados');
  },

  async descargarPDF() {
    const c = this.data.certificado;
    if (!c) return;

    toast.info('Generando PDF...');

    try {
      if (typeof html2pdf === 'undefined') {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.2/html2pdf.bundle.min.js';
          script.onload = resolve;
          script.onerror = () => reject(new Error('Error al cargar librería PDF'));
          document.head.appendChild(script);
        });
      }

      // Importar la vista de impresión y generar HTML en contenedor temporal
      const { default: PrintCertificado } = await import('./PrintCertificado.js');
      const response = await ventasService.obtenerCertificado(c.id);
      const certificado = response.data || response;
      const html = PrintCertificado.generateHTML.call(PrintCertificado, certificado);

      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.innerHTML = html;
      document.body.appendChild(tempDiv);

      const printContent = tempDiv.querySelector('.cv');

      const opt = {
        margin: [5, 5, 5, 5],
        filename: `AMX-VTA-FR-09_${c.num_serie}.pdf`,
        image: { type: 'png', quality: 1 },
        html2canvas: { scale: 3, useCORS: true, scrollY: 0, letterRendering: true },
        jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
        pagebreak: { mode: 'avoid-all' }
      };

      await html2pdf().set(opt).from(printContent).save();
      document.body.removeChild(tempDiv);
      toast.success('PDF descargado');
    } catch (error) {
      toast.error('Error al generar PDF');
      console.error(error);
    }
  },

  async completarCertificado() {
    // Si hay cambios pendientes, exigir guardar primero
    if (this._hasUnsaved) {
      toast.warning('Guarde los cambios antes de completar el certificado');
      return;
    }

    const c = this.data.certificado;
    const form = document.getElementById('formEditCertificado');
    const formData = new FormData(form);

    // Verificar que los 9 ítems estén marcados
    const protocolo_items = ITEMS_PROTOCOLO.map((item, i) => ({
      item_numero: i + 1,
      verificado: !!formData.get(`protocolo_${i}`)
    }));

    const todosVerificados = protocolo_items.every(p => p.verificado);
    if (!todosVerificados) {
      this.showTab('protocolo');
      toast.error('Debe verificar los 9 ítems del protocolo para completar');
      return;
    }

    // Validar firmas persistidas
    if (!c.firma_empresa_url || !c.firma_cliente_url) {
      this.showTab('firmas');
      toast.error('Debe capturar ambas firmas para completar');
      return;
    }

    if (!confirm('¿Está seguro de completar este certificado? Una vez completado no se podrá editar.')) return;

    try {
      const data = {
        protocolo_items,
        completada: true
      };

      this._showProgress('Completando certificado...');
      await ventasService.actualizarCertificado(c.id, data);
      this._hideProgress();
      this._clearUnsaved();
      toast.success('Certificado completado exitosamente');

      // Recargar para reset de pads + re-render
      await this.cargarCertificado(c.id);
    } catch (error) {
      this._hideProgress();
      toast.error(error.message || 'Error al completar certificado');
      console.error(error);
    }
  }
};
